'use client'

import dynamic from 'next/dynamic'
import { useSticky } from 'pdp/src/components/Sticky/hooks/useSticky'
import type { CommonProps } from 'pdp/src/types/CommonProps'
import { type JSX, type ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

type StickyProps = Pick<CommonProps, 'product' | 'look'>

const DynamicStickyContent = dynamic(() =>
	import('./StickyContent').then((mod) => mod.StickyContent)
)

export function Sticky({ product, look }: Readonly<StickyProps>): ReactNode {
	const { show } = useSticky(look)

	return (
		<ClientPortal selector='sticky-content' show={show}>
			<DynamicStickyContent product={product} look={look} />
		</ClientPortal>
	)
}

type ClientPortalProps = {
	readonly children: JSX.Element
	readonly show: boolean
	readonly selector: string
}

function ClientPortal({ children, selector, show }: ClientPortalProps) {
	const [element, setElement] = useState<HTMLElement | null>(null)

	useEffect(() => {
		setElement(document.getElementById(selector))
	}, [selector])

	return show && element ? createPortal(children, element) : null
}
